import { NotificationQueryEnum } from '@/model/entities/entity-model';
import { StringFns } from '@/shared/string-fns';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { environment } from 'environments/environment';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { firstValueFrom } from 'rxjs';

export interface TemplatePreviewDialogParams {
  /** Html with placeholder tokens */
  template: string;
  /** Whether to convert html to plain text */
  isText: boolean;
  queryId: NotificationQueryEnum;
  /** json e.g. "{ accountId: 123, jobOrderId: 456 }" */
  context: string;
}

@Component({
  template: `
  <div class="h-full flex flex-col" >
    <div class="grow" [innerHTML]="content">
    </div>
    <div class="text-right">
      <button (click)="close()" pButton type="button" icon="pi pi-times" label="Close" class="p-button-raised p-button-sm"></button>
    </div>
  </div>`,
  standalone: false
})
export class TemplatePreviewDialogComponent implements OnInit {

  /** html with values merged */
  content?: SafeHtml;
  data: TemplatePreviewDialogParams;

  constructor(dialogConfig: DynamicDialogConfig, private ref: DynamicDialogRef, private domSanitizer: DomSanitizer, private httpClient: HttpClient) {
    this.data = dialogConfig.data;
  }

  public static async openDialog(dialogService: DialogService, data: TemplatePreviewDialogParams, config?: DynamicDialogConfig<TemplatePreviewDialogParams>) {
    const ref = dialogService.open(TemplatePreviewDialogComponent, {
      closable: false,
      draggable: true,
      width: '780px',
      height: '70vh',
      focusOnShow: false,
      ...config,
      data: data,
    });
    return firstValueFrom(ref.onClose);
  }

  async ngOnInit(): Promise<void> {
    this.showContent();
  }

  async showContent(): Promise<void> {
    const url = environment.entitiesApiRoot + (this.data.isText ? '/MergeTemplateText' : '/MergeTemplateHtml');
    const body = {
      template: this.data.template,
      notificationQueryId: this.data.queryId,
      contextJson: this.data.context,
    };
    try {
      const merged = await firstValueFrom(this.httpClient.post<{ Value: string }>(url, body));
      const content = merged ? StringFns.purify(merged.Value, { ADD_TAGS: ['style'], FORCE_BODY: true }) : 'no content';
      this.content = this.domSanitizer.bypassSecurityTrustHtml(content);
    } catch {
      this.content = 'Unable to preview';
    }
  }

  close() {
    this.ref.close();
  }

}
